import { createDestinationMapAPIClient } from './destinationMapAPIClient'

export const destinationMapAPIClient = createDestinationMapAPIClient()

export type DestinationMapAPIClient = typeof destinationMapAPIClient
